import QuestionList from '../questionlist/QuestionList.vue'


export default {
    components: { QuestionList },
    name: 'lessonstudy',
    data() {
        return {
            //获取试题的id
            testID: '',
            //判断时长字段是否存在
            isRate: true,
            //学习按钮的字
            studyText: '',
            //我的订单的商品id
            orderGoodsId: '',
            //总课时
            sumClass: 0,
            //课程隐藏
            // huodong:false,
            // ziyuan:false,
            //已完成课时
            continueClass: {},
            finishedClass: 0,
            //项目详情
            classDetails: {},
            //产品详情
            projectDetails: {},
            resources: [{
                name: '',
                items: [{
                    name: '',
                    resources: []
                }]
            }],
            //项目
            assignment: [],
            //辅导员
            instructor: {},
            //班级介绍
            introduction: {},
            // tabresources: {},
            class_id: '',
            id: '',
            //班级文件
            classfile: [],
            //班级公告
            bulletin: [],
            //进度条成功参数
            active: 1,
            visible: false,
            // 项目大纲
            outline: [],
            // 提示框触发延迟时间
            openDelay: 500,
            //正在进行时的任务的排序
            task_index: '',
            //正在进行时的活动排序
            activite_sort_index: '',
            //重新整理的任务数组
            outlineXin: '',
            //剩余时间
            remaining: '',
            //项目进度
            progress: 0,
            //icon
            ActiveIconStatus: ['-icon-gray.png', '-icon-blue.png', '-icon-green.png'],
            //green
            img: 'https://education-test.bayou-tech.cn/img/class-icon-green.png',


        }
    },
    methods: {

        //跳转首页
        goIndex: function () {
            this.$router.push({
                path: '/'
            })
        },

        //跳转到视频观看
        toLearnVideo(index1, index2) {
            let data = {
                goodsId: this.id,
                product_id: this.id,
                project_id: this.projectDetails.id,
                purchased_id: this.classDetails.purchased_id,
                taskState_index: index1,
                activeState_index: index2
            }
            data = this.crypto_js(JSON.stringify(data))
            this.$router.push({
                name: 'studyhomepage',
                query: {
                    data: data,
                    product_id: this.id
                },
            })

        },

        //跳转到项目式详情
        todetailsPage(id) {
            this.$router.push({
                path: '/detailsPage',
                query: {
                    id: id
                }
            })
        },

        //跳转到云课程详情
        toclassdetails(id) {
            this.$router.push({
                path: '/classdetails',
                query: {
                    id: id
                }
            })
        },

        //跳转到云课程学习页
        toclassstudy(id) {
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: id
                }
            })
        },

        //获取产品信息
        getresources() {
            return (this.$post('products/get_pay', {
                token: this.$store.state.id,
                id: this.id
            })
                .then(res => {
                    // console.log('获取产品信息', res.data.result)
                    this.classDetails = res.data.result
                    this.$post('projects/search', {
                        token: this.$store.state.id,
                        id: res.data.result.project_id
                    }).then(res => {
                        // console.log('获取项目信息', res.data.result)
                        this.projectDetails = res.data.result
                        this.intervalTime(this.changeDate(), this.projectDetails.end_study_time)//计算剩余时间
                        this.getClassinformation()  //获取班级信息
                        this.getjindu()
                    })
                })
            );
        },

        //获取班级信息
        getClassinformation() {
            this.$post('class_users/get_class_by_purchased_id', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                purchased_id: this.classDetails.purchased_id
            })
                .then(res => {



                    // console.log('班级信息'+res.data.status);
                    // console.log('班级信息返回'+res.data.result);
                    // console.log('miss',this.$isAbnormal(this.introduction))
                    if (!this.$isAbnormal(res.data.result)) {
                        // alert(111);
                        this.introduction = res.data.result
                        // console.log('班级信息',res.data.result)
                        this.getinstructor() //获取辅导员
                        this.getclassbulletin()  //获取班级公告
                        this.getclass_file() //查询班级文件
                    }

                })
        },

        //获取辅导员
        getinstructor() {
            // console.log('辅导员',this.introduction.instructor_id);
            if (this.$isAbnormal(this.introduction.instructor_id)) {
                this.instructor = [];
                return false
            }
            this.$post('instructor/get', {
                token: this.$store.state.id,
                id: this.introduction.instructor_id
            })
                .then(res => {

                    // console.log('辅导员信息',res.data.result)
                    this.instructor = res.data.result
                })
        },

        //获取班级公告
        getclassbulletin() {
            // 若还没有班级，不存在则不请求数据
            if (this.$isAbnormal(this.introduction.id)) {
                this.bulletin = [{ bulletin: '还没有分配班级，请等待班级分配' }];
                return false
            }
            this.$post('class_bulletin/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 100,
                class_id: this.introduction.id
            }).then(res => {
                // console.log('班级公告',res.data.result.data)
                this.bulletin = res.data.result.data
            })

        },

        //查询班级文件
        getclass_file() {
            //若还没有班级，则不请求数据
            if (this.$isAbnormal(this.introduction.id)) {
                this.classfile = [];
                return false
            }
            this.$post('class_file/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 100,
                class_id: this.introduction.id
            }).then(res => {
                // console.log('班级文件', res.data.result.data)
                this.classfile = res.data.result.data
            })
        },

        //查询项目大纲
        getoutline() {
            this.$post('project_tasks/search_group_by_task', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                project_id: this.projectDetails.id
            }).then(res => {
                this.outline = res.data.result.data.map((res) => {
                    for (let i = 0; i < res.task_activities.length; i++) {
                        res.task_activities[i].resources = JSON.parse(res.task_activities[i].resources)
                        //  console.log(res.task_activities[i].resources) 
                    }
                    return res
                })
                this.outline[0].taskState = 1
                this.outline[0].task_activities[0].activeState = 1
                this.shujuchul()
                //this.zhenglixiangmushuzhu()
                // console.log('项目大纲', this.outline)
            })
        },

        // 判断课程是否购买
        judgeBuy() {
            let BZ //是否购买变量
            let is_project
            this.$post('users/isPay', {//返回true则没有购买，返回false就说明已经购买
                token: this.$store.state.id,
                product_id: this.id,
            }).then(res => {
                // console.log('是否购买', res.data.result)
                BZ = res.data.result
                this.$post('products/get', { //返回is_project =1 是项目式  0 是云课程
                    token: this.$store.state.id,
                    id: this.id,
                }).then(res => {
                    // console.log('判断课程类型', res)
                    // console.log('判断课程类型', res.data.result.is_project)
                    is_project = res.data.result.is_project
                    if (BZ == true) {//没有购买
                        if (is_project == 1) {
                            this.todetailsPage(this.id)//跳转至项目式详情页
                        } else {
                            this.toclassdetails(this.id)//跳转至云课程详情页
                        }
                    } else {
                        if (is_project == 1) {
                            this.getresources()  //获取信息数据
                        } else {
                            this.toclassstudy(id)(this.id)//跳转至云课程学习页
                        }

                    }
                })
            })
        },

        // 查询进度并查询项目大纲
        getjindu() {
            this.$post('purchased/get', {
                token: this.$store.state.id,
                id: this.classDetails.purchased_id
            }).then(res => {
                let data = res.data.result
                this.progress = +(data.progress * 100).toFixed(0) //保存总进度
                // console.log('总进度 = ' + this.progress)
                // console.log("this.outline ", res.data.result);
                //  this.outline1 = JSON.parse(data.rate)
                if (data.rate == null || data.rate == '') {
                    this.getoutline()//无进度获取项目大纲
                    // console.log('无进度大纲')
                } else {
                    this.outline = JSON.parse(data.rate)//有进度获取进度数据
                    // console.log("this.outline ", this.outline);
                    this.shujuchul()
                }

            })
        },

        //数据处理
        shujuchul() {
            // 查找当前进行的任务
            for (let i = 0; i < this.outline.length; i++) {
                if (this.outline[i].taskState == 1) {
                    this.task_index = this.outline[i].sort
                    break
                }
            }
            // 查找和当前任务一样排序的任务
            for (let i = 0; i < this.outline.length; i++) {
                if (this.outline[i].sort == this.task_index && this.outline[i].taskState != 2) {
                    this.outline[i].taskState = 1
                    let tt = true
                    for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                        if (this.outline[i].task_activities[j].activeState == 1) {
                            tt = false
                            this.activite_sort_index = this.outline[i].task_activities[j].activite_sort//当前活动的排序
                            for (; j < this.outline[i].task_activities.length; j++) {
                                if (this.outline[i].task_activities[j].activite_sort == this.activite_sort_index && this.outline[i].task_activities[j].activeState != 2) {
                                    this.outline[i].task_activities[j].activeState = 1
                                }
                            }
                        }
                    }
                    if (tt) {//没有找到
                        this.outline[i].task_activities[0].activeState = 1
                        this.activite_sort_index = this.outline[i].task_activities[0].activite_sort//当前活动的排序
                        for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                            if (this.outline[i].task_activities[j].activite_sort == this.activite_sort_index && this.outline[i].task_activities[j].activeState != 2) {
                                this.outline[i].task_activities[j].activeState = 1
                            }
                        }
                    }
                }
            }
            // console.log('已处理大纲数据：', this.outline)
            // 保存进度
            let json1 = JSON.stringify(this.outline)
            this.$post('purchased/sumbitRate', { token: this.$store.state.id, id: this.classDetails.purchased_id, rate: json1 })

            // console.log('进度：' ,this.outline)
        },

        //继续学习
        continueLearning() {
            // let index1 = 0
            // let index2 = 0
            // this.$post('purchased/get', {
            //     token: this.$store.state.id,
            //     id:  this.classDetails.purchased_id 
            // }).then(res => {
            //     this.outline = JSON.parse(res.data.result.rate)//有进度获取进度数据
            //     for(let i=0;i<this.outline.length;i++){
            //         if(this.outline[i].lasttime != ""){
            //              index1 = i
            //              index2 = this.outline[i].lasttime.activeIndex
            //              break
            //         } 
            //      }
            //      this.toLearnVideo(index1,index2)//跳转到视频界面
            // })
            UIkit.switcher(study).show(1);
        },

        //去除重复元素
        removeRepeatArray(arr) {
            return arr.filter(function (item, index, self) {
                return self.indexOf(item) === index;
            });
        },

        //获取数据
        getIcon() {
            this.$post('icon/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                type: '',
                state: ''
            })
        },


        //时区日期格式转换(TZ)
        changeDate() {
            let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
            // console.log('当前时间', date)
            return date;
        },
        //时区日期格式转换(TZ)
        intervalTime(startTime, endTime) {
            var date1 = new Date(startTime);  //开始时间
            var date2 = new Date(endTime);    //结束时间
            var date3 = date2.getTime() - date1.getTime();  //时间差的毫秒数
            //计算出相差天数
            var days = Math.floor(date3 / (24 * 3600 * 1000));
            //计算出小时数
            var leave1 = date3 % (24 * 3600 * 1000);    //计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / (3600 * 1000));
            //计算相差分钟数
            var leave2 = leave1 % (3600 * 1000);        //计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2 / (60 * 1000));
            //计算相差秒数
            var leave3 = leave2 % (60 * 1000);      //计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3 / 1000);
            //alert(" 用时： " + days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒")
            this.remaining = days
        },

        /**
        * @author  :  zgg
        * @created :  2019/07/1
        * @version :  v1.0
        * @desc    :  url传参加密
        */
        crypto_js(pas) {
            var CryptoJS = require("crypto-js");
            var ciphertext = CryptoJS.AES.encrypt(pas + '', '18888888888').toString();
            return ciphertext
        },

        // 学习进度100时点击继续学习调用该方法
        showTips() {
            this.$alert('您已经完成该课程的学习', '提示', {
                confirmButtonText: '确定'
            });
        }


    },


    mounted() {

    },

    created() {

        // console.log('密文', this.crypto_js())
        this.id = this.$route.query.id //页面跳转传递id
        this.judgeBuy()   // 判断课程是否购买  判断课程类型
        // this.getClassinformation() //获取班级信息
    },
}

